<div class="connector">
  <div class="connector-dropdown">
    <div
      class="connector-toggle"
      #connectorMenuTrigger="matMenuTrigger"
      [matMenuTriggerFor]="connectorMenu"
      [@highlightAnimTrigger]="highlightState"
      (@highlightAnimTrigger.start)="highlightStart()"
      (@highlightAnimTrigger.done)="highlightDone()"></div>
    <mat-menu [overlapTrigger]="false" #connectorMenu="matMenu" class="connector__popup">
      <app-connector-list
        *ngIf="connectorMenuTrigger.menuOpen"
        [flMxKey]="mxKey"></app-connector-list>
    </mat-menu>
  </div>
</div>
